import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import initCamera from './initCamera.js'
import opener from './opener.js'

export default contract({
  initCamera: array([
    initCamera
  ]),
  opener: array([
    opener
  ])
})